module.exports = __webpack_public_path__ + "img/Thayers.208005ab.png";